import { useState, useEffect, React, useRef } from "react";
import "./Landing.css";
import { Dropdown } from 'react-bootstrap';
import { apiHelper } from "../lib/ApiHelper";
import PopUp from "./popUp";
import BulkPopUp from "./BulkPopUp";
import ReprintBulk from "../BulkPopUP/BulkReprintPopUp";
import TitleDeletePopup from "./titleDeletePopup";
import PRHLoader from "../lib/PRHLoader";
import BulkAgendaPopUp from "./BulkAgendaPopUp";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule
]);
import { LicenseManager } from "@ag-grid-enterprise/core";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

const formatDate = (value) => {
    try {
        if (!value) return '';
        const date = new Date(value);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth is 0-based, so add 1
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    } catch {
        return '';
    }
}

export default function SideNav(props) {
    const [ISBNList, setISBNList] = useState([]);
    const [alertMessage, setAlertMessage] = useState("");
    const [messageCSS, setmessageCSS] = useState("");
    const [titleList, setTitleList] = useState([]);
    const [agendaList, setAgendaList] = useState(null);
    const [selectedAgenda, setSelectedAgenda] = useState(null);
    const [titleDeleteActive, setTitleDeleteActive] = useState(false);
    const [newListName, setNewListName] = useState(null);
    const [isSort, setIsSort] = useState(() => {
        const saved = sessionStorage.getItem('isSort');
        return saved === 'true' ? true : false;
    });
    const [titleSelected, setTitleSelected] = useState(0);
    const [isUpdating, setUpdating] = useState(false);
    const [titleName, setTitleName] = useState('');
    const [selectedISBN, setselectedISBN] = useState('');
    const [popupActive, setPopupActive] = useState(false);
    const [bulkActive, setBulkActive] = useState(false);
    const [reprintActive, setReprintActive] = useState(false);
    const [titlePopUpActive, setTitlePopUpActive] = useState(false);
    const [isNewTitleList, setIsNewTitleList] = useState(false);
    const [isAgendaPopUp, setisAgendaPopUp] = useState(false);
    const [titleIsPrivate, setTitleIsPrivate] = useState(null);
    const [isOwner, setIsOwner] = useState(null);
    const [savedListPopUp, setSavedListPopUp] = useState(false);
    const [titleListLoading, setTitleListLoading] = useState(false);
    const gridApi = useRef(null);
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);

    const closeTitlePopUp = () => {
        setTitlePopUpActive(false);
        setPopupActive(false);
        setAlertMessage("");
    }
    const clearFilters = () => {
        gridApi.current.setFilterModel(null);
        gridApi.current.onFilterChanged();
    }

    const columnDefs = [
        {
            headerName: "List Name", field: "listname", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 130, tooltipValueGetter: (p) => p.value, headerComponentParams: {
                menuIcon: "whiteFilterIcon",
            },
        },

        {
            headerName: "List Type", field: "publicOrPrivate", headerClass: "HeaderClassSource header-text-left", cellClass: "CellClassSource cell-text-left", width: 100,
        },

        {
            headerName: "Created By", field: "createdby", headerClass: "HeaderClassSource header-text-left", cellClass: "CellClassSource cell-text-left", width: 190, tooltipValueGetter: (p) => p.value,
        },

        {
            headerName: "Last Updated", field: "lastupdated", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right",
            filter: "agDateColumnFilter",
            valueGetter: (params) => {
                if (!params.data.lastupdated || params.data.lastupdated === "0001-01-01T00:00:00") return null;
                return new Date(params.data.lastupdated); // Return actual Date object for filtering
            },
            valueFormatter: (params) => {
                return showFormatDate(params.value); // Display formatted date in MM/DD/YYYY
            },
            filterParams: {
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1; // Handle empty cases
                    const cellDate = new Date(cellValue);
                    return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
                }, filterPlaceholder: (params) => {
                    switch (params.filterOptionKey) {
                        case "greaterThanOrEqual":
                            return "Enter start date...";
                        case "lessThanOrEqual":
                            return "Enter end date...";
                        case "inRange":
                            return "Select range...";
                        default:
                            return params.placeholder; // Default behavior
                    }
                }
            }, width: 130
        },
    ];
    const [gridOptions, setgridOption] = useState({
        defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
        },
        icons: {
            whiteFilterIcon: '<svg width="16" height="16" viewBox="0 0 1024 1024" fill="white"><path d="M128 192h768l-288 288v256l-192 192v-448z"/></svg>'
        },
        animateRows: true,
        accentedSort: true,
        suppressDragLeaveHidesColumns: true, // ? stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        suppressRowClickSelection: true,
        //  onSelectionChanged: onSelectionChanged,
        //  rowSelection: 'multiple',
    },
    )


    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return "";
    }
    const deleteTitleList = async () => {
        try {
            if (titleSelected > 0) {
                const payload = [{
                    comments: "",
                    outputcolumns: "",
                    upn: props.upn,
                    isprivate: true,
                    listname: titleName,
                    listid: titleSelected,
                    listtypeid: 1,
                    listvalues: []
                }];
                const data = await apiHelper.inventoryUserPostCall("deletelist", payload);
                setTitleName('');
                setTitleSelected(0);
                setTitleDeleteActive(prev => !prev);
                setTimeout(fetchTitleList, 1000);
                setTitleIsPrivate(null);
                setIsOwner(null);
            }
        } catch (error) { console.log(error); }
    }

    const onClose = () => {
        setTitleDeleteActive(prev => !prev);
    }

    const saveTitleList = async (titleName, flag, existingTitle = null, isPrivate = true) => {
        try {
            var listValues = ISBNList.map((e, i) => { return e.isbn + "." + (i + 1) })
            const titleId = flag == false && existingTitle && existingTitle > 0 ? existingTitle : -1;
            var listid = titleSelected;

            const payload = {
                comments: "",
                outputcolumns: "",
                upn: props.upn,
                isprivate: isPrivate,
                listname: titleName,
                listid: titleId,
                listtypeid: 1,
                listvalues: listValues

            };
            const response = await apiHelper.inventoryUserPostCall("savelist", payload);
            if (response.error != null && response.error != "" && response.error.length > 0) {
                setmessageCSS("errorUser");
                setAlertMessage(response.error);
            }
            else {
                listid = response.listid;
                setmessageCSS("successUser");
                setAlertMessage("Title saved successfully!");
                setTitleIsPrivate(isPrivate);
                setIsOwner(true);
            }
        }
        catch (error) {
            console.log(error);
            setmessageCSS("errorUser");
            setAlertMessage("Somthing went wrong !");
  
        }
        finally {
            fetchTitleList();
            setTitleSelected(listid);
            setNewListName(titleName);
            setTitleName(titleName);
            setUpdating(false);

        }
    }


    const onGridReady = async (params) => {
        gridApi.current = params.api;

        // Get today's date
        const today = new Date();
        today.setDate(today.getDate() + 1);
        today.setHours(0, 0, 0, 0);

        // Get date from 2 years ago
        const twoYearsAgo = new Date();
        twoYearsAgo.setFullYear(today.getFullYear() - 1);
        twoYearsAgo.setHours(0, 0, 0, 0);

        setTimeout(() => {
            params.api.setFilterModel({
                lastupdated: {
                    type: "inRange",
                    dateFrom: twoYearsAgo.toISOString().split("T")[0], // Format: YYYY-MM-DD
                    dateTo: today.toISOString().split("T")[0] // Format: YYYY-MM-DD
                }
            });
            params.api.onFilterChanged(); // Apply filter
        }, 100);
    };
    useEffect(() => {
        if (props.isbnData.listISBN) {
            let distinctDates = [...new Set(props.isbnData.listISBN
                .map(item => item.agendaDate)
                .filter(agendaDate => agendaDate !== null && agendaDate !== undefined))];
            distinctDates = distinctDates.sort((a, b) => new Date(a) - new Date(b));
            setAgendaList(distinctDates);
        }
    }, [props.isbnData.listISBN])

    const fetchTitleList = async () => {
        try {
            setTitleListLoading(true);
            const data = await apiHelper.inventoryUserPostCall("retrieveuserlists", { upn: props.upn, groups: props.groups, index: "us-titles" });
            /* let result = [];
             if (data != null && data != undefined) {
                 var userlist = data.userlists;
                 result = userlist.map(({ listid, listname }) => ({ listid, listname }));
             }
             const sortedList = result.sort((a, b) => {
                 if (a.listname < b.listname) return -1;
                 if (a.listname > b.listname) return 1;
                 return 0;
             });*/
            /*  const sortedLists = [...data.userlists].sort(
                  (a, b) => new Date(b.lastupdated) - new Date(a.lastupdated)
              );
              setTitleList(sortedLists);*/
            setTitleList(data.userlists);
        } catch (error) { console.log(error); } finally {
            setTitleListLoading(false);
            setSelectedAgenda(null);
        }
    }

    const ISBNClick = (e) => {
        let isbn;
        let audience;
        if (e != undefined && e != null) {
            isbn = e.currentTarget.getAttribute('data-value');
            audience = e.currentTarget.getAttribute('data-aud');
        } else {
            isbn = ISBNList[0].isbn;
        }
        if (isbn != selectedISBN && isbn != '') {
            setselectedISBN(isbn);
            props.loadMetaData(isbn);
            props.setISBNAudience(audience);
            props.setIsMetaLoading(true);
        }
    }


    const getISBNFromTitleList = async (listId) => {
        try {
            const data = await apiHelper.inventoryUserPostCall("retrievelistvalues", { upn: props.upn, listId: listId });
            if (data.data != null && data.data != undefined) {
                await apiHelper.ISBNValidation(data.data.map((e) => { return e.value }).toString(), props.upn, props.isbnData, props.setIsbnData);
            }
            else {
                props.setIsbnData({
                    listISBN: [],
                    Loading: false,
                    duplicates: [],
                    invalid: []
                });
                props.setISBNId('');
                await apiHelper.handleReplaceList([], props.upn, true);
            }
        } catch (error) {
            console.error("getISBNFromTitleList error", error);
        }

    }
    const clearISBN = () => {

        props.setIsbnData({
            listISBN: [],
            Loading: false,
            duplicates: [],
            invalid: []
        });
        //props.setISBNId('');
        setTitleIsPrivate(null);
    }
    const selectTitle = (e) => {
        props.setIsbnData({
            listISBN: [],
            Loading: false,
            duplicates: [],
            invalid: []
        });
        setSelectedAgenda(null);
        setTitleSelected(e.target.value);
        //var index = e.target.selectedIndex;
        // var selectedTitleName = e.target.options[index].text;
        setTitleName(e.target.name);
        getISBNFromTitleList(e.target.value);
    }

    const selectTitlemanually = (e) => {
        clearISBN();
        setTitleSelected(e.target.value);
        setSelectedAgenda(null);
        setTitleName(e.target.name);
        getISBNFromTitleList(e.target.value);
    }

    const selectAgendaFilter = (e) => {
        if (e.target.value === "x") {
            setSelectedAgenda(null);
        } else {
            const agendaClick = e.target.value;
            setSelectedAgenda(agendaClick);
            let isbn;
            if (agendaClick != null) {
                const filteredISBNList = ISBNList.filter(i => i.agendaDate === agendaClick);
                isbn = filteredISBNList?.length > 0 ? filteredISBNList[0].isbn : null;
                if (isbn != selectedISBN && isbn != '' && isbn != null) {
                    setselectedISBN(isbn);
                    props.loadMetaData(isbn);
                    props.setIsMetaLoading(true);
                }
            }
        }
    }


    const closeBulkPopUp = (payload = null) => {
        if (bulkActive) {

            if (payload != null) {
                const isbnReload = payload?.isbnList.find(i => i == selectedISBN);

                if (isbnReload) {
                    props.setMetaData(payload);
                }
            }

            setBulkActive(false);
        } else setBulkActive(true)
    }

    const handleReprintsBulk = () => {
        setReprintActive(prev => !prev);
    }

    useEffect(() => {
        if (props.upn != null && props.upn.length > 0) {
            fetchTitleList();
        }
    }, [props.upn]);

    const sortListIsbn = () => {
        const sortedList = [...props.isbnData.listISBN].sort((a, b) => {
            if (a.title < b.title) return -1;
            if (a.title > b.title) return 1;
            return 0;
        });
        setISBNList(sortedList);
    }

    useEffect(() => {
        const paramData = props?.params ? props?.params.split(",") : [];
        if (props?.upn && props.upn != "") {
            if (paramData && paramData.length > 0) {
                props.emptyUrlParams();
                const prepend = false;
                const fromOverView = true;
                const updateSetTitle = false;
                apiHelper.ISBNCheck(paramData, props.upn, props.setIsbnData, props.isbnData, prepend, fromOverView, updateSetTitle);
            } else {
                if (props.isbnData.listISBN && props.isbnData.listISBN.length > 0) {
                } else {
                    getDataFromSaved();
                }
            }
        }
    }, [props.upn])

    const getDataFromSaved = async () => {
        try {
            const data = await apiHelper.inventoryPostCall("savedTitleV2", { value: props.upn });
            if (data && data?.length > 0) {
                props.setIsbnData(prev => ({ ...prev, listISBN: data }));
            } else {
                props.setIsbnData(prev => ({ ...prev, listISBN: [] }));
            }
        } catch (error) {
            console.error("savedTitle failed");
        }
    }

    const setIsbnData = async () => {
        if (!isSort) {
            setISBNList(props.isbnData.listISBN);
        } else sortListIsbn();
    }

    const selectTitleFromList = (listTitle) => {
        const selectedOption = titleList.find(item => item.listname === listTitle);
        if (selectedOption) {
            const event = {
                target: {
                    value: selectedOption.listid,
                    name: listTitle,
                },
            };
            selectTitlemanually(event); // Manually call the selectTitle function with simulated event
            setTitleIsPrivate(selectedOption.isprivate);
            setIsOwner(selectedOption.isowner);
        } else {
            console.debug('Title not found');
        }
    }
    const handleRowClicked = async (event) => {
        const data = {
            target: {
                value: event.data.listid,
                name: event.data.listname,
            },
        };
        await selectTitle(data);
        setIsOwner(event.data.isowner);
        setTitleIsPrivate(event.data.isprivate);
        setSavedListPopUp(false);
    };
    useEffect(() => {
        setIsbnData();
    }, [props.isbnData.listISBN])

    useEffect(() => {
        if (ISBNList.length > 0) ISBNClick();
    }, [ISBNList])

    useEffect(() => {
        if (newListName && newListName != "") {
            selectTitleFromList(newListName);
        }
    }, [newListName])

    useEffect(() => {
        sessionStorage.setItem('isSort', isSort.toString());
        setIsbnData();
    }, [isSort])

    useEffect(() => {
        if (!savedListPopUp) {
            const today = new Date();
            today.setDate(today.getDate() + 1);
            today.setHours(0, 0, 0, 0);
          
            // Get date from 2 years ago
            const twoYearsAgo = new Date();
            twoYearsAgo.setFullYear(today.getFullYear() - 1);
            twoYearsAgo.setHours(0, 0, 0, 0);
            
            setTimeout(() => {
                gridApi.current.setFilterModel({
                    lastupdated: {
                        type: "inRange",
                        dateFrom: twoYearsAgo.toISOString().split("T")[0], // Format: YYYY-MM-DD
                        dateTo: today.toISOString().split("T")[0] // Format: YYYY-MM-DD
                    }
                });
                gridApi.current.onFilterChanged(); // Apply filter
            }, 100);
        }
    }, [savedListPopUp])


    const handleClickOutside = event => {
        if (
            inputRef.current &&
            !inputRef.current.contains(event.target) &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            setSavedListPopUp(false);
        }
    }

    useEffect(() => {
        // Add event listener on mount
        document.addEventListener('mousedown', handleClickOutside);
        // Cleanup the event listener on unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (
        <div className="container-fluid sideNav">
            <div className="select-title ">
                <div className="side-head">Saved Lists</div>

                <div ref={inputRef} className="custom-input select-custom" title={titleName} onClick={() => setSavedListPopUp(prev => !prev)}>{titleName != "" ? titleName : 'Select List'}</div>

                <div ref={dropdownRef} className={`savedList-dropdown ${savedListPopUp ? 'active-hgt' : ''}`}>
                    {/*    {savedListPopUp && <div className={"savedList-dropdown"}>*/}
                    <div className="dropdown-header">
                        <span className="fw-bold ml-1 select-dropdown-header">Select List  {<button onClick={clearFilters} className="ISBNSubmit mt-0 mb-0">Clear Filters</button>}
                        </span>


                        <button onClick={() => setSavedListPopUp(prev => !prev)} className="ISBNSubmit close-dropdown-btn mt-0 mb-0 mr-1"
                        >
                            Close Dropdown <span className="drop-up-arrow"></span>
                        </button>

                    </div>
                    {titleListLoading && titleList.length < 1 && <PRHLoader></PRHLoader>}
                    <div className="ag-theme-balham" style={{ width: "100%", height: "65vh", overflow: "auto" }}>
                        <AgGridReact
                            rowData={titleList}
                            columnDefs={columnDefs}
                            gridOptions={gridOptions}
                            onRowClicked={handleRowClicked}
                            onGridReady={onGridReady}
                        ></AgGridReact>
                    </div>
                </div>

            </div>



            <div className="side-head" style={{ padding: '0px', marginBottom: '16px' }}>Title List   {props.isbnData.listISBN?.length > 0 && <span style={{ fontSize: '12px', marginLeft: "auto" }}>Total ISBNs: {props.isbnData.listISBN.length}</span>}
            </div>
            <div>
                {props.isbnData.listISBN.length > 1 && (
                    <label >
                        <input
                            type="checkbox"
                            value={isSort}
                            className="mr-1"
                            style={{ marginLeft: "14px" }}
                            id="isSort"
                            name="isSort"
                            onChange={() => setIsSort(prev => !prev)}
                            checked={isSort}
                        />
                        ABC
                    </label>
                )}
                {< label className="dropicon ml-auto">
                    <select className="custom-input agenda-filter" value={selectedAgenda ?? ''} onChange={selectAgendaFilter} disabled={!agendaList || agendaList.length <= 0}>
                        <option value="x">Agenda Date</option>
                        {agendaList && agendaList.length > 0 && agendaList.map((item) => {
                            return (<option value={item}>{formatDate(item)}</option>)
                        })}
                    </select>
                </label>}
            </div>
            {props.isbnData.listISBN.length > 1 && <div style={{ fontSize: '10px', marginLeft: "14px", fontStyle: 'italic' }}>Click a title to see its metadata.</div>}
            {props.isbnData.listISBN?.length > 0 &&
                <div id="sidebar">
                    <div id="side" style={{ maxHeight: '400px', overflowX: "hidden", overflowY: "auto", marginTop: '0px', paddingBottom: '5px' }}>
                        <div>
                            {
                                ISBNList.filter(item => !selectedAgenda || item.agendaDate === selectedAgenda).map((item, index) => { return (<span className="link" key={item.isbn}><span className={item.isbn == selectedISBN ? "nav-span active-nav" : "nav-span"} data-value={item.isbn} data-aud={item.audience} title={(item.isbn.concat("-", item.fmt))} onClick={ISBNClick}>{item.title}</span></span>) })
                            }
                        </div>
                    </div>
                </div>
            }{props.isbnData.Loading && props.isbnData.listISBN.length < 1 && <PRHLoader></PRHLoader>}
            <Dropdown>
                <Dropdown.Toggle id="dropdown-basic" className="ISBNSubmit manually-add">
                    List Actions
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => { setIsNewTitleList(false); setTitlePopUpActive(true) }} disabled={titleSelected <= 0 || !isOwner}>Save</Dropdown.Item>
                    <Dropdown.Item onClick={() => { setIsNewTitleList(true); setTitlePopUpActive(true) }}>Save As</Dropdown.Item>
                    <Dropdown.Item onClick={() => { setTitleDeleteActive(prev => !prev) }} disabled={titleSelected <= 0 || !isOwner}>Delete</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown><br />
            <button className="ISBNSubmit " onClick={() => setPopupActive(true)}>Manually Add ISBNs</button><br />
            <Dropdown>
                <Dropdown.Toggle id="dropdown-basic" className="ISBNSubmit manually-add">
                    Bulk Update
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={closeBulkPopUp} disabled={props?.audience === ''}>Status</Dropdown.Item>
                    <Dropdown.Item onClick={handleReprintsBulk} disabled={props?.audience === ''}>Reprints</Dropdown.Item>
                    {props.audience === 'DK' && <Dropdown.Item onClick={() => setisAgendaPopUp(true)}>Agenda Section</Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>
            {props.isbnData.invalid && props.isbnData.invalid.length > 0 ? <div className="isbn-alert duplicate pb-2 pt-2">
                ISBNs not found: {props.isbnData.invalid.length}
                {props.isbnData.invalid.map((item, index) => {
                    return (
                        <div key={`invalidisbn-${index}`} className="invalid-isbn">{index + 1}. {item}</div>)
                })}
            </div> : null}
            {props.isbnData.duplicates && props.isbnData.duplicates.length > 0 ? <div className="isbn-alert duplicate pb-2 pt-2">
                Duplicate ISBN: {props.isbnData.duplicates.length}
                {props.isbnData.duplicates.map((item, index) => {
                    return (
                        <div key={`invalidisbn-${index}`} className="invalid-isbn" title={item.title}>{index + 1}. {item}</div>)
                })}
            </div> : null}
            {popupActive || titlePopUpActive ? < PopUp setIsNewTitleList={setIsNewTitleList} isNewTitleList={isNewTitleList} isTitleListPopUp={titlePopUpActive} title={titleName} setISBNId={props.setISBNId} upn={props.upn} isbnData={props.isbnData} setIsbnData={props.setIsbnData} closeTitlePopUp={closeTitlePopUp} saveTitleList={saveTitleList} titleList={titleList} titleIsPrivate={titleIsPrivate} setTitleIsPrivate={setTitleIsPrivate} isOwner={isOwner} titleSelected={titleSelected}
                setUpdating={setUpdating}
                isUpdating={isUpdating}
                messageCSS={messageCSS}
                alertMessage={alertMessage}
                setAlertMessage={setAlertMessage}
                setmessageCSS={setmessageCSS}
                titleListLoading={titleListLoading}
            ></PopUp > : <></>}

            {bulkActive &&
                <BulkPopUp
                    ISBNList={props.isbnData.listISBN}
                    upn={props.upn}
                    onClose={closeBulkPopUp}
                    isbnData={props.setIsbnData}
                    audience={props?.audience}
                />}
            {reprintActive &&
                <ReprintBulk
                    ISBNList={props.isbnData.listISBN}
                    upn={props.upn}
                    onClose={handleReprintsBulk}
                    setIsbnData={props.setIsbnData}
                    reprintActive={reprintActive}
                    audience={props?.audience}
                />}
            {isAgendaPopUp &&
                <BulkAgendaPopUp
                    ISBNList={props.isbnData.listISBN}
                    setisAgendaPopUp={setisAgendaPopUp}
                    upn={props.upn}
                    onClose={closeBulkPopUp}
                    isbnData={props.setIsbnData}
                    audience={props?.audience}
                ></BulkAgendaPopUp>}
            {titleDeleteActive && <TitleDeletePopup onClose={onClose} titleDeleteActive={titleDeleteActive} deleteTitleList={() => deleteTitleList()}  ></TitleDeletePopup>}
            <div className="side-head qck-link">Quick Links</div>
            <ul className="quick-links">
                <li><a target="_blank" href="https://myhouse.penguinrandomhouse.com/v2/">MyHouse</a>  </li>
                <li><a target="_blank" href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${selectedISBN}&tab=19&compFlag=N&compISBN=&primaryTitleOption=single`}>Sales Weekly Tracking</a></li>
                <li><a target="_blank" href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${selectedISBN}&tab=20&load_isbn_list=true&return=search&returnURL=/v2/search`}>MyHouse &ndash; MyPlans   </a></li>
                <li><a target="_blank" href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${selectedISBN}&tab=4&load_isbn_list=true&return=search&returnURL=/title.cfm`}>MyHouse &ndash; Events</a></li>
                <li><a target="_blank" href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${selectedISBN}&tab=11`}>MyHouse &ndash; TI Sheet </a></li>
                <li><a target="_blank" href="https://myhouse.penguinrandomhouse.com/SalesPortal/report_criteria.cfm">MyReports</a></li>
                <li><a target="_blank" href="https://tnt.penguinrandomhouse.com/time-series">TNT &ndash; Book Graph</a></li>
                <li><a target="_blank" href="https://app.powerbi.com/groups/me/apps/5b9c1e69-0c9a-43fe-bc04-5ee0f38f0975/reports/fe7ae69d-17f9-4600-9fd6-d0d7d243f52a/ReportSection0caf66c15855156929cd?ctid=35a3d2a4-3172-457d-8b65-131efb2a337e&experience=power-bi">Tempest</a></li>
                <li><a target="_blank" href="https://www.amazon.com/">Amazon </a></li>
                <li><a target="_blank" href="https://ourhouse.penguinrandomhouse.com/resources/services/operations-center/transportation-2/">Transportation</a></li>
                <li><a target="_blank" href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${selectedISBN}&tab=7`}>MyHouse/Sales Estimates</a></li>
                <li><a target="_blank" href={`https://app.powerbi.com/groups/me/apps/5b9c1e69-0c9a-43fe-bc04-5ee0f38f0975/reports/93c83482-d71c-4d28-a6c6-1ea1386dc24f/ReportSection?ctid=35a3d2a4-3172-457d-8b65-131efb2a337e&experience=power-bi&bookmarkGuid=Bookmarkaeebe801d1daf3a5efda`}>Operations Landing Page</a></li>
                <li><a target="_blank" href={`https://app.powerbi.com/groups/me/apps/5b9c1e69-0c9a-43fe-bc04-5ee0f38f0975/reports/7ff1a918-afd9-4eb3-bf8f-009641761ca3/ReportSectionb821950c908e9beae591?ctid=35a3d2a4-3172-457d-8b65-131efb2a337e&experience=power-bi`}>Flux Capacitor</a></li>
            </ul>
        </div>
    )
}